/*
 * cart-essentials.js — site-wide cart helpers while the cart drawer script is
 * not loaded (see layout/theme.liquid: cart-essentials.js vs cart-drawer.js).
 *
 * If you restore the cart drawer:
 *   1. In theme.liquid: load cart-drawer.js and stop loading this file.
 *   2. In cart-drawer.js: uncomment the "SITE-WIDE CART HELPERS" block at the
 *      bottom of that file (drawer-specific updateCartUI + checkout listeners).
 */

window.__dkCartSilent = false;

function hasCartChanged(prevCart, nextCart) {
  if (!prevCart || !nextCart) return false;
  if (prevCart.item_count !== nextCart.item_count) return true;

  const prevItems = (prevCart.items || []).map((i) => `${i.variant_id}:${i.quantity}`);
  const nextItems = (nextCart.items || []).map((i) => `${i.variant_id}:${i.quantity}`);

  if (prevItems.length !== nextItems.length) return true;
  for (let idx = 0; idx < prevItems.length; idx += 1) {
    if (prevItems[idx] !== nextItems[idx]) return true;
  }
  return false;
}
window.hasCartChanged = window.hasCartChanged || hasCartChanged;

window.updateCartUI = async function updateCartUI(willOpen = false, baselineCart = null) {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const url = `${root}cart/update.js?dk_silent=1`;

  try {
    window.__dkCartSilent = true;

    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-DK-Silent": "1",
      },
      body: JSON.stringify({
        updates: {},
        sections: ["cart-icon-bubble"],
        sections_url: window.location.pathname,
      }),
    });

    const parsedState = await res.json();

    if (!parsedState?.sections) return parsedState;

    const cartIconHtml = parsedState.sections["cart-icon-bubble"];
    if (cartIconHtml) {
      const iconDoc = new DOMParser().parseFromString(cartIconHtml, "text/html");
      const targetIcon = document.getElementById("cart-icon-bubble");
      const sourceIcon = iconDoc.querySelector(".shopify-section");
      if (targetIcon && sourceIcon) {
        targetIcon.innerHTML = sourceIcon.innerHTML;
      }
    }

    return parsedState;
  } catch (error) {
    console.error("Error updating cart:", error);
    return null;
  } finally {
    setTimeout(() => {
      window.__dkCartSilent = false;
    }, 80);
  }
};

window.refreshCartUI = window.updateCartUI;

document.addEventListener("DOMContentLoaded", () => {
  window.updateCartUI(false);

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === "cart-items" || event.source === "product-form" || event.source === "product-form-post-silent") {
        return;
      }
      window.updateCartUI(false);
    });
  }
});

(() => {
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    cartFreebiesCheckoutSubmitting = false;
    closeFreebiesModal({ restoreFocus: false });
    initializeCartCheckoutButtons();
    window.updateCartUI(false);

    document.querySelectorAll("[data-cart-checkout-button]").forEach((btn) => {
      if (!btn.classList.contains("cart-checkout-button--loading")) return;
      btn.classList.remove("cart-checkout-button--loading", "cart-checkout-button--locked");
      btn.removeAttribute("disabled");
      btn.removeAttribute("aria-disabled");
      if (btn.dataset.originalHtml) {
        btn.innerHTML = btn.dataset.originalHtml;
        delete btn.dataset.originalHtml;
      }
    });
  }
});

let cartFreebiesModalCheckoutButton = null;
let cartFreebiesCheckoutSubmitting = false;
let cartFreebiesBodyHadOverflowHidden = false;

function parseFreebiesNumber(value) {
  const parsedValue = Number.parseInt(value, 10);
  return Number.isFinite(parsedValue) && parsedValue >= 0 ? parsedValue : null;
}

function normalizeFreebiesCount(selected, allowed) {
  const normalizedAllowed = parseFreebiesNumber(allowed);
  if (!normalizedAllowed) return { selected: 0, allowed: 0 };

  return {
    selected: parseFreebiesNumber(selected) ?? 0,
    allowed: normalizedAllowed,
  };
}

function parseFreebiesCountText(text) {
  const match = String(text || "").match(/(\d+)\s*\/\s*(\d+)/);
  if (!match) return { selected: 0, allowed: 0 };

  return normalizeFreebiesCount(match[1], match[2]);
}

function getFreebiesCountFromPanel(type) {
  const picker = document.querySelector("[data-cart-picker-root]");
  if (!picker || picker.hidden || picker.hasAttribute("hidden")) {
    return { selected: 0, allowed: 0 };
  }

  const panel = picker.querySelector(`[data-tab-panel="${type}"]`);
  if (!panel || panel.hidden || panel.hasAttribute("hidden")) {
    return { selected: 0, allowed: 0 };
  }

  const statusElement =
    panel.querySelector(`[data-freebies-type="${type}"]`) ||
    panel.querySelector(".cart-page-picker__status");

  if (statusElement?.dataset.selectedCount !== undefined && statusElement?.dataset.allowedCount !== undefined) {
    return normalizeFreebiesCount(statusElement.dataset.selectedCount, statusElement.dataset.allowedCount);
  }

  const counterElement =
    panel.querySelector(`[data-freebies-counter="${type}"]`) ||
    panel.querySelector(".cart-page-picker__status-counter");

  return parseFreebiesCountText(counterElement?.textContent || statusElement?.textContent);
}

function getFreebiesSelectionState() {
  return {
    samples: getFreebiesCountFromPanel("samples"),
    gifts: getFreebiesCountFromPanel("gifts"),
  };
}

function hasUnselectedFreebies(state = getFreebiesSelectionState()) {
  return Object.values(state).some(({ selected, allowed }) => allowed > 0 && selected < allowed);
}

function getFreebiesModal() {
  const modals = Array.from(document.querySelectorAll("[data-cart-freebies-modal]"));
  if (!modals.length) return null;

  const embeddedModal = modals.find((modal) => modal.parentElement !== document.body);
  return embeddedModal || modals[0];
}

function cleanupDuplicateFreebiesModals() {
  const modal = getFreebiesModal();
  if (!modal) return;

  document.querySelectorAll("[data-cart-freebies-modal]").forEach((otherModal) => {
    if (otherModal !== modal && otherModal.hidden) otherModal.remove();
  });
}

function cleanupStaleFreebiesModalState() {
  const modal = getFreebiesModal();
  if (!document.body.classList.contains("cart-freebies-modal-open") || (modal && !modal.hidden)) return;

  document.body.classList.remove("cart-freebies-modal-open");
  if (!cartFreebiesBodyHadOverflowHidden) {
    document.body.classList.remove("overflow-hidden");
  }
  document.removeEventListener("keydown", handleFreebiesModalKeydown);
  cartFreebiesModalCheckoutButton = null;
}

function openFreebiesModal(checkoutButton) {
  const modal = getFreebiesModal();
  if (!modal) {
    continueToCheckout(checkoutButton);
    return;
  }

  initializeFreebiesModal();
  cartFreebiesModalCheckoutButton = checkoutButton;
  cartFreebiesBodyHadOverflowHidden = document.body.classList.contains("overflow-hidden");

  modal.hidden = false;
  modal.removeAttribute("aria-hidden");
  document.body.classList.add("overflow-hidden", "cart-freebies-modal-open");
  document.addEventListener("keydown", handleFreebiesModalKeydown);

  const dialog = modal.querySelector('[role="dialog"]');
  requestAnimationFrame(() => {
    if (typeof trapFocus === "function" && dialog) {
      trapFocus(dialog, dialog);
      return;
    }
    dialog?.focus();
  });
}

function closeFreebiesModal({ restoreFocus = true } = {}) {
  const modal = getFreebiesModal();
  if (!modal || modal.hidden) return;

  modal.hidden = true;
  modal.setAttribute("aria-hidden", "true");
  document.body.classList.remove("cart-freebies-modal-open");
  if (!cartFreebiesBodyHadOverflowHidden) {
    document.body.classList.remove("overflow-hidden");
  }
  document.removeEventListener("keydown", handleFreebiesModalKeydown);

  const focusTarget =
    restoreFocus && cartFreebiesModalCheckoutButton?.isConnected ? cartFreebiesModalCheckoutButton : null;

  if (typeof removeTrapFocus === "function") {
    removeTrapFocus(focusTarget);
  } else if (focusTarget) {
    focusTarget.focus();
  }

  cartFreebiesModalCheckoutButton = null;
}

function getStickyHeaderOffset() {
  const rootStyle = window.getComputedStyle(document.documentElement);
  const cssHeaderHeight = Number.parseFloat(rootStyle.getPropertyValue("--header-height")) || 0;
  const header = document.querySelector(".section-header");
  const headerRect = header?.getBoundingClientRect();
  const visibleHeaderHeight = headerRect && headerRect.top <= 0 && headerRect.bottom > 0 ? headerRect.bottom : 0;

  return Math.max(cssHeaderHeight, visibleHeaderHeight, 0) + 16;
}

function scrollToFreebiesSection() {
  const target =
    document.querySelector(".cart-samples-gifts-tabs__inner") ||
    document.getElementById("cart-samples-gifts-tabs");
  if (!target) return;

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const scrollTop = Math.max(0, target.getBoundingClientRect().top + window.scrollY - getStickyHeaderOffset());

  if (!target.hasAttribute("tabindex")) {
    target.setAttribute("tabindex", "-1");
    target.addEventListener("blur", () => target.removeAttribute("tabindex"), { once: true });
  }

  target.focus({ preventScroll: true });
  window.scrollTo({
    top: scrollTop,
    behavior: prefersReducedMotion ? "auto" : "smooth",
  });
}

function continueToCheckout(checkoutButton) {
  if (!checkoutButton || cartFreebiesCheckoutSubmitting || checkoutButton.hasAttribute("disabled")) return;

  const formId = checkoutButton.getAttribute("form");
  const form = formId ? document.getElementById(formId) : null;
  if (!form) return;

  cartFreebiesCheckoutSubmitting = true;

  const cartFooter = checkoutButton.closest("#main-cart-footer");
  const checkoutButtons = cartFooter
    ? cartFooter.querySelectorAll("[data-cart-checkout-button]")
    : [checkoutButton];
  const processingText = window.cartStrings?.processing || "Processing...";

  checkoutButtons.forEach((btn) => {
    if (!btn.dataset.originalHtml) {
      btn.dataset.originalHtml = btn.innerHTML;
    }
    btn.setAttribute("disabled", "");
    btn.setAttribute("aria-disabled", "true");
    btn.classList.add("cart-checkout-button--loading", "cart-checkout-button--locked");
    btn.textContent = processingText;
  });

  if (!form.querySelector('input[name="checkout"]')) {
    const checkoutInput = document.createElement("input");
    checkoutInput.type = "hidden";
    checkoutInput.name = "checkout";
    checkoutInput.value = "";
    form.appendChild(checkoutInput);
  }
  form.submit();
}

function handleFreebiesModalClick(event) {
  if (event.target.closest("[data-cart-freebies-skip]")) {
    const checkoutButton = cartFreebiesModalCheckoutButton;
    closeFreebiesModal({ restoreFocus: false });
    continueToCheckout(checkoutButton);
    return;
  }

  if (event.target.closest("[data-cart-freebies-select]")) {
    closeFreebiesModal({ restoreFocus: false });
    scrollToFreebiesSection();
    return;
  }

  if (event.target.closest("[data-cart-freebies-close]")) {
    closeFreebiesModal();
  }
}

function handleFreebiesModalKeydown(event) {
  if (event.key !== "Escape") return;
  event.preventDefault();
  closeFreebiesModal();
}

function initializeFreebiesModal() {
  const modal = getFreebiesModal();
  if (!modal || modal.dataset.freebiesModalInitialized === "true") return;

  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  modal.addEventListener("click", handleFreebiesModalClick);
  modal.dataset.freebiesModalInitialized = "true";
}

function handleCheckoutButtonClick(event) {
  const checkoutButton = event.target.closest("[data-cart-checkout-button]");
  if (!checkoutButton || checkoutButton.hasAttribute("disabled")) return;

  event.preventDefault();

  if (cartFreebiesCheckoutSubmitting) return;

  if (hasUnselectedFreebies()) {
    openFreebiesModal(checkoutButton);
    return;
  }

  continueToCheckout(checkoutButton);
}

function initializeCartCheckoutButtons() {
  cleanupDuplicateFreebiesModals();
  cleanupStaleFreebiesModalState();
  initializeFreebiesModal();

  const cartFooter = document.getElementById("main-cart-footer");
  if (cartFooter && !cartFooter.dataset.checkoutListenerAdded) {
    cartFooter.addEventListener("click", handleCheckoutButtonClick);
    cartFooter.dataset.checkoutListenerAdded = "true";
  }
}

window.initializeCartCheckoutButtons = initializeCartCheckoutButtons;
document.addEventListener("DOMContentLoaded", initializeCartCheckoutButtons);
})();
